import React, { Suspense } from 'react';

import { ErrorBoundary } from '@/components/ui/ErrorBoundary';
import { Spinner } from '@/components/ui/Spinner';

const DefaultFallback = (
  <div className="flex justify-center items-center min-h-screen">
    <Spinner />
  </div>
);

interface RouteShellProps {
  /** Shown while the lazily loaded page is downloading */
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

/** Wraps every route: its own error boundary (one broken page doesn't take down the app) + Suspense. */
export const RouteShell: React.FC<RouteShellProps> = ({ fallback = DefaultFallback, children }) => (
  <ErrorBoundary>
    <Suspense fallback={fallback}>{children}</Suspense>
  </ErrorBoundary>
);
